/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Box, Alert } from 'sarsaparilla';
import { INVENTORY_VENUE_RESERVATIONS, INVENTORY_VENUE_APPLICATION } from '../constants';

function FuturePaymentBox({ reservations = [] }) {
    let amount = 0;
    let venuesOrderNeedsApproval = false;
    for (let i = 0; i < reservations.length; i++) {
        const res = reservations[i];
        const orderDetails = get(res, 'order_details', {});
        amount += Number(get(orderDetails, 'pending_payment_amount', '0.00'));
        if (amount === 0 && !venuesOrderNeedsApproval) {
            venuesOrderNeedsApproval =
                (res?.inventory_type === INVENTORY_VENUE_RESERVATIONS ||
                    res?.inventory_type === INVENTORY_VENUE_APPLICATION) &&
                get(orderDetails, 'needs_approval', 'false') === 'true';
        }
    }

    const commonContent = () => {
        return (
            <div>
                <Alert type="warning" heading="Future Payments">
                    This order may require future payments. Please consult the reservation
                    details for more information.
                </Alert>
            </div>
        );
    };

    const box = () => {
        return (
            <Box padding="md" background="gray-2">
                {commonContent()}
            </Box>
        );
    };

    if (amount > 0 || venuesOrderNeedsApproval) {
        return box();
    }
    return null;
}

FuturePaymentBox.propTypes = {
    reservations: PropTypes.object,
};

export default FuturePaymentBox;
